module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored@2x-defd70d133a85e9fda8f0afece1da656.png";